module.exports = __webpack_public_path__ + "img/mu.1229bed5.svg";